import EventLabel2 from "../../../../../components/EventLabel2/EventLabel2";
import React from "react";

import noResult from "../../emptyStates/no-result.svg";
import { eventLabelGroupsConstants } from "../../../../constants/eventLabelGroups.contansts";
export const NoResultState = () => {
  return (
    <div style={{ position: "relative", width: "100%", height: "100%" }}>
      <div
        className=" text-center"
        style={{ flexDirection: "column", display: 'flex' }}
      >
    {/*     <img src={noResult} style={{ margin: "auto", maxWidth: 250 }} /> */}
        <EventLabel2
          name="NoResult"
          groupName={eventLabelGroupsConstants.CHAT_LABEL_GROUP}
        />
      </div>
    </div>
  );
};
